var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row"},[_c('transition',{attrs:{"name":"left","appear":""}},[_c('shop',{staticClass:"w-75"})],1),_c('transition',{attrs:{"name":"right","appear":""}},[_c('cart',{staticClass:"w-25"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }